import { Role } from '@jaam/commons/constants';

export const PAYROLL_ROUTES = [
  {
    path: '/home',
    roles: [Role.Admin, Role.Accountant],
  },
  {
    path: '/staff',
    roles: [Role.Admin, Role.Accountant],
  },
  {
    path: '/company/information',
    roles: [Role.Admin],
  },
  {
    path: '/company/members',
    roles: [Role.Admin],
  },
  // {
  //   path: '/company/plan',
  //   roles: [Role.Admin],
  // },
  {
    path: '/company/payroll-elements',
    roles: [Role.Admin],
  },
  {
    path: '/company/billing-items',
    roles: [Role.Admin],
  },
  {
    path: '/company/teams',
    roles: [Role.Admin],
  },
  {
    path: '/pay',
    roles: [Role.Admin, Role.Accountant],
  },
  {
    path: '/pay/periods',
    roles: [Role.Admin, Role.Accountant],
  },
  {
    path: '/pay/periods/:periodId/payslips',
    roles: [Role.Admin, Role.Accountant],
  },
  {
    path: '/pay/periods/:periodId/taxes',
    roles: [Role.Admin, Role.Accountant],
  },
  {
    path: '/pay/cnps/:cnpsDeclarationId/details',
    roles: [Role.Admin, Role.Accountant],
  },
  {
    path: '/staffRequest',
    roles: [Role.Admin, Role.Accountant, Role.Staff],
  },
  {
    path: '/loan-requests',
    roles: [Role.Admin, Role.Accountant, Role.Staff],
  },
  {
    path: '/transactions',
    roles: [Role.Admin, Role.Accountant],
  },
  {
    path: '/migration',
    roles: [Role.Admin, Role.Accountant],
  },
  {
    path: '/admin',
    roles: [Role.Admin],
  },
  {
    path: '/admin/list',
    roles: [Role.Admin],
  },
  {
    path: '/staff/:selectedItemId/contracts',
    roles: [Role.Admin, Role.Accountant],
  },
  {
    path: '/staff/:staffId/contracts/:newContract',
    roles: [Role.Admin, Role.Accountant],
  },
  {
    path: '/staffInvoice',
    roles: [Role.Admin, Role.Accountant, Role.Staff],
  },
];
